import Header from './components/Header';
import Hero from './components/Hero';
import AppSection from './components/AppSection';
import MediaSection from './components/MediaSection';
import CarouselSection from './components/CarouselSection';
import AboutSection from './components/AboutSection';
import IndexSection from './components/IndexSection';
import CardsSection from './components/CardsSection';
import CommentsSection from './components/CommentsSection';
import FaqSection from './components/FaqSection';
import RankingSection from './components/RankingSection';
import TopicsSection from './components/TopicsSection';
import ContactSection from './components/ContactSection';
import UpdatesSection from './components/UpdatesSection';
import FeaturesSection from './components/FeaturesSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <AppSection />
        <MediaSection />
        <CarouselSection />
        <AboutSection />
        <IndexSection />
        <CardsSection />
        <CommentsSection />
        <FaqSection />
        <RankingSection />
        <TopicsSection />
        <ContactSection />
        <UpdatesSection />
        <FeaturesSection />
      </main>
      <Footer />
    </>
  );
}